import { AboutModal } from '@patternfly/react-core';
import { FunctionComponent } from 'react';

import brandPlaceholder from '../assets/about-brand-placeholder.svg';
import { About } from '../components/About/About';

export interface IAboutModal {
  handleCloseModal: () => void;
  isModalOpen: boolean;
}

/*
 * `productName` is the wordmark here. The brand image is required by PatternFly and deliberately
 * empty: the only logo in the tree is the upstream project's, and this dialog is open to everyone
 * who signs in.
 */
export const KaotoAboutModal: FunctionComponent<IAboutModal> = ({ handleCloseModal, isModalOpen }) => {
  return (
    <AboutModal
      isOpen={isModalOpen}
      onClose={handleCloseModal}
      trademark=""
      brandImageSrc={brandPlaceholder}
      brandImageAlt=""
      data-testid="about-modal"
      productName="Casa"
    >
      <About />
    </AboutModal>
  );
};
